<template>
  <button v-if="inBookmarks"
          @click.prevent="$emit('toggle')"
          class="base-btn  base-btn--outline-blue  _active">
    <BaseSvg name="ico-heart"/>
    <span class="d-sm-none">{{ $tVacancy('Saved') }}</span>
    <BasePreloader v-if="pending"/>
  </button>
  <button v-else
          @click.prevent="$emit('toggle')"
          class="base-btn  base-btn--outline-blue">
    <BaseSvg name="ico-heart-outline"/>
    <span class="d-sm-none">{{ $tVacancy('Save') }}</span>
    <BasePreloader v-if="pending"/>
  </button>
</template>

<script>
  export default {
    name: 'VacancyMainBookmarksBtn',
    props: {
      inBookmarks: Boolean,
      pending: Boolean,
    }
  }
</script>

<style lang="less">

</style>
